import { metafieldFragment } from './utils'

export const getCollectionId = /* GraphQL */ `
	query getCollectionId($handle: String!) {
		collectionByHandle(handle: $handle) {
			id
		}
	}
`

export const collectionProductFragment = /* GraphQL */ `
	fragment collectionProduct on Product {
		id
		title
		vendor
		handle
		productType
		avgRating: metafield(namespace: "loox", key: "avg_rating") {
			...metafield
		}
		numReviews: metafield(namespace: "loox", key: "num_reviews") {
			...metafield
		}
		priceRange {
			minVariantPrice {
				amount
				currencyCode
			}
			maxVariantPrice {
				amount
				currencyCode
			}
		}
		variants(first: 100) {
			nodes {
				id
				quantityAvailable
				sku
				title
				priceV2 {
					amount
					currencyCode
				}
				compareAtPriceV2 {
					amount
					currencyCode
				}
				isSample: metafield(namespace: "my_fields", key: "is_sample") {
					...metafield
				}
				isNMC: metafield(namespace: "custom", key: "nmc_visible_") {
					...metafield
				}
				isRMC: metafield(namespace: "custom", key: "rmc_visable") {
					...metafield
				}
				hide: metafield(namespace: "custom", key: "hide") {
					...metafield
				}
				image {
				url
				altText
				width
				height
				}
			}
		}
		images(first: 1) {
			edges {
				node {
					id
					url
					altText
					width
					height
				}
			}
		}
		collections(first: 10) {
			edges {
				node {
					handle
				}
			}
		}
	}
`

export const getCollectionProductsQuery = /* GraphQL */ `
	query getCollectionProducts(
		$collectionHandle: String
		$first: Int = 250
		$sortKey: ProductCollectionSortKeys = COLLECTION_DEFAULT
		$reverse: Boolean = false
		$after: String = null
		$filters: [ProductFilter!] = []
	) {
		collection(handle: $collectionHandle) {
			id
			title
			handle
			descriptionHtml
			seo {
				description
				title
			}
			image {
				id
				url
				altText
				width
				height
			}
			products(
				first: $first
				sortKey: $sortKey
				reverse: $reverse
				after: $after
				filters: $filters
			) {
				filters {
					id
					label
					type
					values {
						id
						label
						count
						input
					}
				}
				pageInfo {
					hasNextPage
					hasPreviousPage
					endCursor
				}
				edges {
					node {
						...collectionProduct
					}
				}
			}
		}
	}

	${collectionProductFragment}
	${metafieldFragment}
`
